
import { Link } from 'react-router-dom';

const services = [
  {
    id: 1,
    title: '若年層向けプラン',
    subtitle: '20〜30代の方へ',
    description: '将来に備える基礎づくり',
    image: 'https://public.readdy.ai/ai/img_res/56b99ae7b9303807e1c1c78ce7042bce.jpg',
    bgColor: 'bg-[#2C3E50]',
    textColor: 'text-white',
  },
  {
    id: 2,
    title: '子育て世代プラン',
    subtitle: '30〜40代の方へ',
    description: '家族の成長に合わせた保障',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20family%20with%20young%20children%20playing%20happily%20at%20home%2C%20parents%20in%20their%2030s%20with%20two%20kids%2C%20warm%20cozy%20living%20room%2C%20natural%20lighting%2C%20casual%20comfortable%20clothing%2C%20simple%20clean%20background%2C%20authentic%20Japanese%20people&width=600&height=700&seq=service-family-001&orientation=portrait',
    bgColor: 'bg-[#FFF5F0]',
    textColor: 'text-[#2C3E50]',
  },
  {
    id: 3,
    title: 'シニア世代プラン',
    subtitle: '50代以上の方へ',
    description: '安心のセカンドライフ設計',
    image: 'https://readdy.ai/api/search-image?query=Happy%20senior%20Japanese%20couple%20in%20their%2060s%20enjoying%20retirement%20life%20together%2C%20smiling%20at%20garden%2C%20casual%20comfortable%20clothing%2C%20warm%20natural%20lighting%2C%20simple%20clean%20background%2C%20authentic%20Japanese%20people&width=600&height=700&seq=service-senior-001&orientation=portrait',
    bgColor: 'bg-[#FFF5F0]',
    textColor: 'text-[#2C3E50]',
  },
];

export default function Services() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-start justify-between mb-12 md:mb-16 gap-4">
          <div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#2C3E50] leading-tight" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              ライフステージ別<br className="hidden sm:block" />
              保険プラン
            </h2>
          </div>
          <p className="text-gray-600 text-base md:text-lg max-w-md md:mt-4">
            お客様一人ひとりの人生設計に合わせた最適なプランをご提案
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={service.id}
              className={`${service.bgColor} rounded-2xl overflow-hidden ${
                index === 0 ? 'md:col-span-1' : ''
              }`}
            >
              {index === 0 ? (
                <div className="p-6 md:p-8 h-full flex flex-col">
                  <div className="mb-4 md:mb-6">
                    <h3 className={`text-2xl md:text-3xl font-bold ${service.textColor} mb-2`}>
                      {service.title}
                    </h3>
                    <p className={`text-base md:text-lg ${service.textColor} opacity-80`}>
                      {service.subtitle}
                    </p>
                  </div>
                  <div className="flex-1 relative rounded-xl overflow-hidden">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              ) : (
                <div className="p-6">
                  <div className="flex items-center gap-2 mb-4">
                    <div className="w-2 h-2 bg-[#FF9B7A] rounded-full"></div>
                    <span className="text-sm text-gray-600">{service.subtitle}</span>
                  </div>
                  <div className="rounded-xl overflow-hidden mb-4 h-64">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <h3 className="text-xl md:text-2xl font-bold text-[#2C3E50] mb-2">
                    {service.title}
                  </h3>
                  <p className="text-sm md:text-base text-gray-600 mb-6">{service.description}</p>
                  <Link
                    to="/services"
                    className="inline-block bg-[#2C3E50] text-white px-6 py-3 rounded-full text-sm md:text-base hover:bg-[#1a252f] transition-colors whitespace-nowrap cursor-pointer"
                  >
                    詳しく見る
                  </Link>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
